import { Component, inject, OnDestroy } from '@angular/core';
import { ImportAbstractDirective, ImportFileTypes } from '../import.abstract.directive';
import { ConfigurationDatabaseResource } from '../../resources/import.abstract.resource';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Observable, throwError } from 'rxjs';
import { SystemStatusContext } from '../../../shared/contexts/system-status.context';
import { delayWhen, map } from 'rxjs/operators';

@Component({
  selector: 'ziro-admin-import-db',
  templateUrl: '../import.abstract.component.html',
  styleUrls: ['../../admin-page.scss', '../import.abstract.component.scss'],
  standalone: false,
})
export class ImportConfigurationComponent extends ImportAbstractDirective implements OnDestroy {
  private _configurationDatabaseResource = inject(ConfigurationDatabaseResource);
  private _breadcrumbsService = inject(BreadcrumbsService);
  private _systemStatusContext = inject(SystemStatusContext);

  warningText = 'tkey;pages.admin.import.warning.text';
  warningTextPreamble = 'tkey;pages.admin.import.warning.preamble.text';

  constructor() {
    super();

    this._breadcrumbsService.updateBreadcrumbs([{ label: 'tkey;pages.admin.import.header' }]);
    this.importFileType = ImportFileTypes.CONFIG;
  }

  ngOnDestroy(): void {
    this._breadcrumbsService.clearBreadcrumbs();
  }

  requestImport = (): Observable<void> => {
    const request = this.getImportRequest();

    if (request) {
      return this._configurationDatabaseResource.post(request).pipe(
        delayWhen(() => this._systemStatusContext.refreshSystemStatus()),
        map(() => {}),
      );
    } else {
      return throwError(null);
    }
  };
}
